import { useInView } from 'react-intersection-observer';
import './GoogleMap.css';

const GoogleMap = () => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1
    });

    // Solaris Cube, Vesu, Surat - AT Architects Office
    // Using q parameter with coordinates ensures a marker is shown at center
    const lat = 21.185568;
    const lng = 72.78809;
    const mapEmbedUrl = `https://maps.google.com/maps?q=${lat},${lng}&z=16&hl=en&output=embed&iwloc=B`;

    return (
        <div ref={ref} className="google-map-container">
            {inView && (
                <iframe
                    src={mapEmbedUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="AT Architects Office Location"
                    className="google-map-iframe"
                />
            )}
            {!inView && (
                <div className="google-map-placeholder">
                    <i className="bi bi-geo-alt-fill"></i>
                    <p>Loading map...</p>
                </div>
            )}
        </div>
    );
};

export default GoogleMap;
